/** Presentation helpers shared by the web app and API-side rendering. */
/** Format a minor-unit (cents) amount as a currency string. */
export function formatMoney(minorUnits, currency = 'USD', locale = 'en-US') {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    }).format(minorUnits / 100);
}
/** Whole nights between two ISO dates (YYYY-MM-DD). */
export function nightsBetween(checkIn, checkOut) {
    const start = Date.parse(checkIn);
    const end = Date.parse(checkOut);
    if (Number.isNaN(start) || Number.isNaN(end))
        return 0;
    const ms = end - start;
    return Math.max(0, Math.round(ms / (1000 * 60 * 60 * 24)));
}
/** Round to a fixed number of decimals without floating-point drift artifacts. */
export function roundTo(value, decimals = 2) {
    const factor = 10 ** decimals;
    return Math.round((value + Number.EPSILON) * factor) / factor;
}
//# sourceMappingURL=format.js.map